import { Skeleton } from "@/shared/ui";

export default function MsbCalculationsPageSkeleton() {
  return (
    <>
      <div className="p-5 radius-3xl surface-base-fill mb-5">
        <div className="flex items-start justify-between gap-4 mb-5">
          <div className="flex items-center gap-3">
            <Skeleton width={40} height={40} borderRadius={8} />
            <div className="flex flex-col gap-1">
              <Skeleton height={20} width={280} />
              <Skeleton height={16} width={160} />
            </div>
          </div>
          <div className="flex flex-col items-end gap-2 shrink-0">
            <Skeleton height={24} width={100} borderRadius={12} />
            <Skeleton height={16} width={180} />
          </div>
        </div>

        <div className="grid grid-cols-[auto_1fr] gap-10 items-center">
          <Skeleton width={210} height={210} borderRadius={105} />
          <div className="grid grid-cols-3 gap-2">
            {Array.from({ length: 3 }).map((_, idx) => (
              <div key={idx} className="p-5 radius-lg border surface-component-stroke flex flex-col">
                <div className="flex items-center gap-3 mb-3">
                  <Skeleton width={32} height={32} borderRadius={8} />
                  <Skeleton height={14} width={100} />
                </div>
                <Skeleton height={28} width="70%" />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="p-5 radius-3xl surface-base-fill">
        <div className="mb-4">
          <Skeleton height={20} width={240} />
        </div>

        <div className="grid grid-cols-2 gap-4 auto-rows-fr">
          <div className="p-6 radius-lg border surface-component-stroke flex flex-col gap-4 row-span-3">
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-3">
                <Skeleton width={40} height={40} borderRadius={8} />
                <div className="flex flex-col gap-1">
                  <Skeleton height={18} width={180} />
                  <Skeleton height={14} width={160} />
                </div>
              </div>
              <Skeleton height={24} width={90} borderRadius={12} />
            </div>
            <Skeleton height={28} width="45%" />
            <div className="flex items-center gap-1">
              {Array.from({ length: 3 }).map((_, idx) => (
                <Skeleton key={idx} height={28} width={90} borderRadius={6} />
              ))}
            </div>
            <div className="flex items-center justify-between mt-auto pt-3 border-t surface-base-stroke">
              <Skeleton height={14} width={50} />
              <Skeleton height={18} width={100} />
            </div>
          </div>

          {Array.from({ length: 3 }).map((_, idx) => (
            <div key={idx} className="p-4 radius-lg border surface-component-stroke flex flex-col gap-3">
              <div className="flex items-start justify-between gap-2">
                <div className="flex items-center gap-2">
                  <Skeleton width={32} height={32} borderRadius={8} />
                  <div className="flex flex-col gap-1">
                    <Skeleton height={14} width={140} />
                    <Skeleton height={12} width={120} />
                  </div>
                </div>
                <Skeleton height={22} width={80} borderRadius={12} />
              </div>
              <Skeleton height={12} width="75%" />
              <div className="flex items-center justify-between pt-2 border-t surface-base-stroke">
                <Skeleton height={12} width={40} />
                <Skeleton height={14} width={80} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
